import Velaris from "@/components/ui/velaris";
import { FadeIn } from "@/components/FadeIn";

export function BrandMessageSection() {
  return (
    <section
      data-testid="brand-message-section"
      className="relative h-[85vh] min-h-[560px] border-t border-white/10 overflow-hidden"
    >
      <Velaris height="100%">
        <div className="h-full w-full flex items-center justify-center container-custom">
          <div className="relative z-10 text-center max-w-3xl mx-auto">
            <FadeIn>
              <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-6xl leading-[1.05] tracking-tight text-white">
                WE DON'T JUST MARKET BUSINESSES.
                <br />
                WE BUILD GROWTH SYSTEMS.
              </h2>
              <p className="mt-8 text-sm md:text-base tracking-wide text-zinc-300">
                Built around your goals. Designed to scale.
              </p>
            </FadeIn>
          </div>
        </div>
      </Velaris>
    </section>
  );
}
